/**
 * @fileoverview gRPC-Web generated client stub for cloud
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var account_pb = require('./account_pb.js')
const proto = {};
proto.cloud = require('./service_account_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.cloud.ServiceModifyAccountClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.cloud.ServiceModifyAccountPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.AccountCreationRequest,
 *   !proto.cloud.AccountCreationResponse>}
 */
const methodDescriptor_ServiceModifyAccount_CreateAccount = new grpc.web.MethodDescriptor(
  '/cloud.ServiceModifyAccount/CreateAccount',
  grpc.web.MethodType.UNARY,
  proto.cloud.AccountCreationRequest,
  proto.cloud.AccountCreationResponse,
  /**
   * @param {!proto.cloud.AccountCreationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.AccountCreationResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.AccountCreationRequest,
 *   !proto.cloud.AccountCreationResponse>}
 */
const methodInfo_ServiceModifyAccount_CreateAccount = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.AccountCreationResponse,
  /**
   * @param {!proto.cloud.AccountCreationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.AccountCreationResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.AccountCreationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.AccountCreationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.AccountCreationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceModifyAccountClient.prototype.createAccount =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceModifyAccount/CreateAccount',
      request,
      metadata || {},
      methodDescriptor_ServiceModifyAccount_CreateAccount,
      callback);
};


/**
 * @param {!proto.cloud.AccountCreationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.AccountCreationResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceModifyAccountPromiseClient.prototype.createAccount =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceModifyAccount/CreateAccount',
      request,
      metadata || {},
      methodDescriptor_ServiceModifyAccount_CreateAccount);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.ProjectCreationRequest,
 *   !proto.cloud.ProjectCreationResponse>}
 */
const methodDescriptor_ServiceModifyAccount_CreateProject = new grpc.web.MethodDescriptor(
  '/cloud.ServiceModifyAccount/CreateProject',
  grpc.web.MethodType.UNARY,
  proto.cloud.ProjectCreationRequest,
  proto.cloud.ProjectCreationResponse,
  /**
   * @param {!proto.cloud.ProjectCreationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.ProjectCreationResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.ProjectCreationRequest,
 *   !proto.cloud.ProjectCreationResponse>}
 */
const methodInfo_ServiceModifyAccount_CreateProject = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.ProjectCreationResponse,
  /**
   * @param {!proto.cloud.ProjectCreationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.ProjectCreationResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.ProjectCreationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.ProjectCreationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.ProjectCreationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceModifyAccountClient.prototype.createProject =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceModifyAccount/CreateProject',
      request,
      metadata || {},
      methodDescriptor_ServiceModifyAccount_CreateProject,
      callback);
};


/**
 * @param {!proto.cloud.ProjectCreationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.ProjectCreationResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceModifyAccountPromiseClient.prototype.createProject =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceModifyAccount/CreateProject',
      request,
      metadata || {},
      methodDescriptor_ServiceModifyAccount_CreateProject);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.ProjectDeletionRequest,
 *   !proto.cloud.ProjectDeletionResponse>}
 */
const methodDescriptor_ServiceModifyAccount_DeleteProject = new grpc.web.MethodDescriptor(
  '/cloud.ServiceModifyAccount/DeleteProject',
  grpc.web.MethodType.UNARY,
  proto.cloud.ProjectDeletionRequest,
  proto.cloud.ProjectDeletionResponse,
  /**
   * @param {!proto.cloud.ProjectDeletionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.ProjectDeletionResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.ProjectDeletionRequest,
 *   !proto.cloud.ProjectDeletionResponse>}
 */
const methodInfo_ServiceModifyAccount_DeleteProject = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.ProjectDeletionResponse,
  /**
   * @param {!proto.cloud.ProjectDeletionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.ProjectDeletionResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.ProjectDeletionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.ProjectDeletionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.ProjectDeletionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceModifyAccountClient.prototype.deleteProject =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceModifyAccount/DeleteProject',
      request,
      metadata || {},
      methodDescriptor_ServiceModifyAccount_DeleteProject,
      callback);
};


/**
 * @param {!proto.cloud.ProjectDeletionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.ProjectDeletionResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceModifyAccountPromiseClient.prototype.deleteProject =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceModifyAccount/DeleteProject',
      request,
      metadata || {},
      methodDescriptor_ServiceModifyAccount_DeleteProject);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.RoleModifyUserRequest,
 *   !proto.cloud.RoleModifyUserResponse>}
 */
const methodDescriptor_ServiceModifyAccount_RoleModifyUser = new grpc.web.MethodDescriptor(
  '/cloud.ServiceModifyAccount/RoleModifyUser',
  grpc.web.MethodType.UNARY,
  proto.cloud.RoleModifyUserRequest,
  proto.cloud.RoleModifyUserResponse,
  /**
   * @param {!proto.cloud.RoleModifyUserRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.RoleModifyUserResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.RoleModifyUserRequest,
 *   !proto.cloud.RoleModifyUserResponse>}
 */
const methodInfo_ServiceModifyAccount_RoleModifyUser = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.RoleModifyUserResponse,
  /**
   * @param {!proto.cloud.RoleModifyUserRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.RoleModifyUserResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.RoleModifyUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.RoleModifyUserResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.RoleModifyUserResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceModifyAccountClient.prototype.roleModifyUser =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceModifyAccount/RoleModifyUser',
      request,
      metadata || {},
      methodDescriptor_ServiceModifyAccount_RoleModifyUser,
      callback);
};


/**
 * @param {!proto.cloud.RoleModifyUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.RoleModifyUserResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceModifyAccountPromiseClient.prototype.roleModifyUser =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceModifyAccount/RoleModifyUser',
      request,
      metadata || {},
      methodDescriptor_ServiceModifyAccount_RoleModifyUser);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.RoleInviteUserRequest,
 *   !proto.cloud.RoleInviteUserResponse>}
 */
const methodDescriptor_ServiceModifyAccount_RoleInviteUser = new grpc.web.MethodDescriptor(
  '/cloud.ServiceModifyAccount/RoleInviteUser',
  grpc.web.MethodType.UNARY,
  proto.cloud.RoleInviteUserRequest,
  proto.cloud.RoleInviteUserResponse,
  /**
   * @param {!proto.cloud.RoleInviteUserRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.RoleInviteUserResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.RoleInviteUserRequest,
 *   !proto.cloud.RoleInviteUserResponse>}
 */
const methodInfo_ServiceModifyAccount_RoleInviteUser = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.RoleInviteUserResponse,
  /**
   * @param {!proto.cloud.RoleInviteUserRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.RoleInviteUserResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.RoleInviteUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.RoleInviteUserResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.RoleInviteUserResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceModifyAccountClient.prototype.roleInviteUser =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceModifyAccount/RoleInviteUser',
      request,
      metadata || {},
      methodDescriptor_ServiceModifyAccount_RoleInviteUser,
      callback);
};


/**
 * @param {!proto.cloud.RoleInviteUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.RoleInviteUserResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceModifyAccountPromiseClient.prototype.roleInviteUser =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceModifyAccount/RoleInviteUser',
      request,
      metadata || {},
      methodDescriptor_ServiceModifyAccount_RoleInviteUser);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.RoleRemoveUserRequest,
 *   !proto.cloud.RoleRemoveUserResponse>}
 */
const methodDescriptor_ServiceModifyAccount_RoleRemoveUser = new grpc.web.MethodDescriptor(
  '/cloud.ServiceModifyAccount/RoleRemoveUser',
  grpc.web.MethodType.UNARY,
  proto.cloud.RoleRemoveUserRequest,
  proto.cloud.RoleRemoveUserResponse,
  /**
   * @param {!proto.cloud.RoleRemoveUserRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.RoleRemoveUserResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.RoleRemoveUserRequest,
 *   !proto.cloud.RoleRemoveUserResponse>}
 */
const methodInfo_ServiceModifyAccount_RoleRemoveUser = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.RoleRemoveUserResponse,
  /**
   * @param {!proto.cloud.RoleRemoveUserRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.RoleRemoveUserResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.RoleRemoveUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.RoleRemoveUserResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.RoleRemoveUserResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceModifyAccountClient.prototype.roleRemoveUser =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceModifyAccount/RoleRemoveUser',
      request,
      metadata || {},
      methodDescriptor_ServiceModifyAccount_RoleRemoveUser,
      callback);
};


/**
 * @param {!proto.cloud.RoleRemoveUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.RoleRemoveUserResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceModifyAccountPromiseClient.prototype.roleRemoveUser =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceModifyAccount/RoleRemoveUser',
      request,
      metadata || {},
      methodDescriptor_ServiceModifyAccount_RoleRemoveUser);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.RoleRevokeUserInviteRequest,
 *   !proto.cloud.RoleRevokeUserInviteResponse>}
 */
const methodDescriptor_ServiceModifyAccount_RoleRevokeUserInvite = new grpc.web.MethodDescriptor(
  '/cloud.ServiceModifyAccount/RoleRevokeUserInvite',
  grpc.web.MethodType.UNARY,
  proto.cloud.RoleRevokeUserInviteRequest,
  proto.cloud.RoleRevokeUserInviteResponse,
  /**
   * @param {!proto.cloud.RoleRevokeUserInviteRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.RoleRevokeUserInviteResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.RoleRevokeUserInviteRequest,
 *   !proto.cloud.RoleRevokeUserInviteResponse>}
 */
const methodInfo_ServiceModifyAccount_RoleRevokeUserInvite = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.RoleRevokeUserInviteResponse,
  /**
   * @param {!proto.cloud.RoleRevokeUserInviteRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.RoleRevokeUserInviteResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.RoleRevokeUserInviteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.RoleRevokeUserInviteResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.RoleRevokeUserInviteResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceModifyAccountClient.prototype.roleRevokeUserInvite =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceModifyAccount/RoleRevokeUserInvite',
      request,
      metadata || {},
      methodDescriptor_ServiceModifyAccount_RoleRevokeUserInvite,
      callback);
};


/**
 * @param {!proto.cloud.RoleRevokeUserInviteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.RoleRevokeUserInviteResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceModifyAccountPromiseClient.prototype.roleRevokeUserInvite =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceModifyAccount/RoleRevokeUserInvite',
      request,
      metadata || {},
      methodDescriptor_ServiceModifyAccount_RoleRevokeUserInvite);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.cloud.ServiceQueryAccountClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.cloud.ServiceQueryAccountPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.AccountStorageRequest,
 *   !proto.cloud.AccountStorageResponse>}
 */
const methodDescriptor_ServiceQueryAccount_ListAccountStorageUsage = new grpc.web.MethodDescriptor(
  '/cloud.ServiceQueryAccount/ListAccountStorageUsage',
  grpc.web.MethodType.UNARY,
  proto.cloud.AccountStorageRequest,
  proto.cloud.AccountStorageResponse,
  /**
   * @param {!proto.cloud.AccountStorageRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.AccountStorageResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.AccountStorageRequest,
 *   !proto.cloud.AccountStorageResponse>}
 */
const methodInfo_ServiceQueryAccount_ListAccountStorageUsage = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.AccountStorageResponse,
  /**
   * @param {!proto.cloud.AccountStorageRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.AccountStorageResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.AccountStorageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.AccountStorageResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.AccountStorageResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceQueryAccountClient.prototype.listAccountStorageUsage =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceQueryAccount/ListAccountStorageUsage',
      request,
      metadata || {},
      methodDescriptor_ServiceQueryAccount_ListAccountStorageUsage,
      callback);
};


/**
 * @param {!proto.cloud.AccountStorageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.AccountStorageResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceQueryAccountPromiseClient.prototype.listAccountStorageUsage =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceQueryAccount/ListAccountStorageUsage',
      request,
      metadata || {},
      methodDescriptor_ServiceQueryAccount_ListAccountStorageUsage);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.AccountUserListRequest,
 *   !proto.cloud.AccountUserListResponse>}
 */
const methodDescriptor_ServiceQueryAccount_ListAccountUsers = new grpc.web.MethodDescriptor(
  '/cloud.ServiceQueryAccount/ListAccountUsers',
  grpc.web.MethodType.UNARY,
  proto.cloud.AccountUserListRequest,
  proto.cloud.AccountUserListResponse,
  /**
   * @param {!proto.cloud.AccountUserListRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.AccountUserListResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.AccountUserListRequest,
 *   !proto.cloud.AccountUserListResponse>}
 */
const methodInfo_ServiceQueryAccount_ListAccountUsers = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.AccountUserListResponse,
  /**
   * @param {!proto.cloud.AccountUserListRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.AccountUserListResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.AccountUserListRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.AccountUserListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.AccountUserListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceQueryAccountClient.prototype.listAccountUsers =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceQueryAccount/ListAccountUsers',
      request,
      metadata || {},
      methodDescriptor_ServiceQueryAccount_ListAccountUsers,
      callback);
};


/**
 * @param {!proto.cloud.AccountUserListRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.AccountUserListResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceQueryAccountPromiseClient.prototype.listAccountUsers =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceQueryAccount/ListAccountUsers',
      request,
      metadata || {},
      methodDescriptor_ServiceQueryAccount_ListAccountUsers);
};


module.exports = proto.cloud;

